module.exports = __webpack_public_path__ + "media/coffin-dance.bcdbe668.mp3";